module.exports = __webpack_public_path__ + "media/NINJAKIDZ_Website_Loop.b05f4d64.mp4";